import { render, staticRenderFns } from "./ListaBanners.vue?vue&type=template&id=3b9acc48&scoped=true&"
import script from "./ListaBanners.vue?vue&type=script&lang=js&"
export * from "./ListaBanners.vue?vue&type=script&lang=js&"
import style0 from "./ListaBanners.vue?vue&type=style&index=0&id=3b9acc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9acc48",
  null
  
)

export default component.exports